import { Component, input, ViewChild } from '@angular/core';
import {
  ApexAxisChartSeries,
  ApexChart,
  ChartComponent,
  ApexDataLabels,
  ApexXAxis,
  ApexPlotOptions,
  NgApexchartsModule,
} from 'ng-apexcharts';
import { TefBoxService } from '../../services/tef-box-service';

export type BarChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  colors: string[];
};

@Component({
  selector: 'app-bar-chart',
  imports: [NgApexchartsModule],
  templateUrl: './bar-chart.html',
  styleUrl: './bar-chart.scss',
})
export class BarChart {
  @ViewChild('chart') chart!: ChartComponent;
  chartOptions = input<BarChartOptions>({
    series: [
      {
        name: 'Valor',
        data: [430, 400, 448],
      },
    ],
    chart: {
      type: 'bar',
      height: 300,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: 30,
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories: ['Crédito', 'Debito', 'PIX'],
    },
    yaxis: {
      labels: {
        formatter: (value) => `R$ ${value.toFixed(2)}`,
      },
    },
    colors: ['#F47920'],
  });

  constructor() {}
}
